import CheckIcon from "@mui/icons-material/Check";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

import type { PreferenceTileView } from "components/Screens/Marketplace/Customer/utils/preferenceTiles";

// Icon names come from PLG_SIGNUP_CONFIG.preferences.tiles[].icon (prototype icon set).
const ICONS: Record<string, typeof WorkOutlineOutlinedIcon> = {
  briefcase: WorkOutlineOutlinedIcon,
  clock: AccessTimeOutlinedIcon,
  monitor: DesktopWindowsOutlinedIcon,
  chat: ChatBubbleOutlineOutlinedIcon,
  award: WorkspacePremiumOutlinedIcon,
  building: ApartmentOutlinedIcon,
  globe: LanguageOutlinedIcon,
  calendar: CalendarTodayOutlinedIcon,
};

interface TileGridProps {
  tiles: PreferenceTileView[];
  selected: string[];
  onToggle: (label: string) => void;
  /** rich = icon tiles (prototype .vtile); plain = check tiles (.tile). */
  variant?: "rich" | "plain";
  columns?: 2 | 3 | 4 | 5;
}

function TileGrid({ tiles, selected, onToggle, variant = "plain", columns = 2 }: TileGridProps) {
  return (
    <div className={`sl-tiles sl-tiles--${variant} sl-tiles--cols-${columns}`}>
      {tiles.map((tile) => {
        const on = selected.includes(tile.label);
        const Icon = ICONS[tile.icon] || WorkOutlineOutlinedIcon;
        return (
          <button
            type="button"
            key={tile.label}
            aria-pressed={on}
            className={variant === "rich" ? `sl-vtile${on ? " sl-vtile--on" : ""}` : `plg-tile${on ? " plg-tile--on" : ""}`}
            onClick={() => onToggle(tile.label)}
          >
            {variant === "rich" ? (
              <>
                <span className="sl-vtile__icon"><Icon fontSize="small" /></span>
                <span className="sl-vtile__check"><CheckIcon fontSize="inherit" /></span>
                <b>{tile.label}</b>
              </>
            ) : (
              <>
                <span className="plg-tick">{on && <CheckIcon fontSize="inherit" />}</span>
                {tile.label}
              </>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default TileGrid;
